import React from 'react';
import { Box, Paper, Button } from '@material-ui/core';
import { history, useDispatch } from 'umi';
import { useSelector } from 'dva';
import { useIntl } from 'umi';
import CloseIcon from '@material-ui/icons/Close';
import VipCard from './components/vipCard';
import OrderCard from './components/orderCard';
import DetailTable from './components/detailTable';

export default () => {
  const dispatch = useDispatch();
  //关于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  const id = history.location?.query?.id;
  const { orderData } = useSelector((state) => state.orderDetail) || {};
  const vipList = [
    {
      label: formatMessage({ id: 'order.order.detail.n01.lbl02' }),
      id: 'memberCode',
    },
    {
      label: formatMessage({ id: 'order.order.detail.n01.lbl03' }),
      id: 'memberCode',
    },
    {
      label: formatMessage({ id: 'order.order.detail.n01.lbl04' }),
      id: 'level',
    },
    {
      label: formatMessage({ id: 'order.order.detail.n01.lbl05' }),
      id: 'mobile',
    },
    {
      label: formatMessage({ id: 'order.order.detail.n01.lbl06' }),
      id: 'name',
    },
    {
      label: formatMessage({ id: 'order.order.detail.n01.lbl07' }),
      id: 'gender',
    },
    {
      label: formatMessage({ id: 'order.order.detail.n01.lbl08' }),
      id: 'birthday',
    },
    // {
    //   label: formatMessage({ id: 'order.order.detail.n01.lbl09' }),
    //   id: 'registerChannel',
    // },
  ];
  const orderList = [
    {
      label: formatMessage({ id: 'order.order.detail.n02.lbl02' }),
      id: 'orderNo',
    },
    // {
    //   label: `${formatMessage({ id: 'order.order.detail.n02.lbl03' })}ID`,
    //   id: 'store',
    // },
    // {
    //   label: formatMessage({ id: 'order.order.detail.n02.lbl04' }),
    //   id: 'storeName',
    // },
    // {
    //   label: formatMessage({ id: 'order.order.detail.n02.lbl05' }),
    //   id: 'company',
    // },
    {
      label: formatMessage({ id: 'order.order.detail.n02.lbl06' }),
      id: 'orderType',
    },
    {
      label: formatMessage({ id: 'order.order.detail.n02.lbl07' }),
      id: 'channel',
    },
    {
      label: formatMessage({ id: 'order.order.detail.n02.lbl08' }),
      id: 'payment',
    },
    {
      label: formatMessage({ id: 'order.order.detail.n02.lbl09' }),
      id: 'tradeTime',
    },
    // {
    //   label: '使用积分',
    //   id: 'usedPoint',
    // },
    {
      label: formatMessage({ id: 'order.order.detail.n02.lbl10' }),
      id: 'amountTotal',
    },
    {
      label: formatMessage({ id: 'order.order.detail.n02.lbl11' }),
      id: 'amountPaid',
    },
    {
      label: formatMessage({ id: 'order.order.detail.n02.lbl12' }),
      id: 'orderStatus',
    },
    {
      label: formatMessage({ id: 'order.order.detail.n01.lbl10' }),
      id: 'deliveryName',
    },
    {
      label: formatMessage({ id: 'order.order.detail.n01.lbl11' }),
      id: 'deliveryMobile',
    },
    {
      label: formatMessage({ id: 'order.order.detail.n01.lbl12' }),
      id: 'deliveryFullAddress',
    },
    // {
    //   label: formatMessage({ id: 'order.order.detail.n01.lbl13' }),
    //   id: 'ailretailbilltype',
    // },
    {
      label: '原订单号',
      id: 'originalOrderNo',
    },
  ];
  React.useEffect(() => {
    dispatch({
      type: 'orderDetail/getOrderDetail',
      payload: {
        values: {
          id,
        },
      },
    });
  }, []);
  return (
    <Box
      data-log={JSON.stringify({
        oid: 'page_offline_store_order_management_detail',
        isPage: true,
        params: {
          initUrl: window.location.origin + window.location.pathname,
        },
        events: ['_pv', '_pd'],
      })}
      display="flex"
      flexDirection="column"
      gap="24px 0"
    >
      <VipCard data={orderData} list={vipList} formatMessage={formatMessage} />
      <OrderCard
        data={orderData}
        list={orderList}
        formatMessage={formatMessage}
      />
      <DetailTable orderData={orderData} formatMessage={formatMessage} />
      <Paper sx={{ padding: '16px 24px', borderRadius: '4px' }}>
        <Button
          sx={{ width: '108px' }}
          variant="contained"
          className="coupons-setting-button"
          color="secondary"
          onClick={() => history.goBack()}
          startIcon={<CloseIcon sx={{ width: '16px', height: '16px' }} />}
        >
          {formatMessage({ id: 'comm.action.btn.16' })}
        </Button>
      </Paper>
    </Box>
  );
};
